<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <!-- <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{path:'/dashboard'}">Dashboard</router-link>
          </li>
        </ul>
      </nav>-->
      <div class="copyright">&copy; {{footerYear}} Fiifi. All rights reserved.</div>
      <div class="copyright">v{{ this.version }}</div>
    </div>
  </footer>
</template>
<script>
const pckg = require("../../../../package.json");
export default {
  computed: {
    version() {
      return pckg.version;
    },
    footerYear() {
      return new Date().getFullYear();
    }
  }
};
</script>
<style>
</style>
